export const PK = `${process.env.REACT_APP_PK}`;
export const paymentMethodConfigurationForPayment ='pmc_1QxTx2Bzi8BGoIWU1MFQjIix';
export const paymentMethodConfigurationForSaveMethod ='pmc_1QxTxMBzi8BGoIWU7TmP07qb';
export const paymentMethodConfigurationForVerification ='pmc_1QxTxZBzi8BGoIWUAmdLcfkZ';
